export enum CurrencyTransactionOperation {
  Sale = 'Sale',
  Purchase = 'Purchase',
}
